export default __webpack_public_path__ + "static/faqBg-d45b0aa88d5c202294b7f0dd9e52fd83.png";